require('./dist/ui-bootstrap-tpls');

module.exports = 'ui.bootstrap';



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-ui-bootstrap/index.js
 ** module id = 330
 ** module chunks = 1
 **/